<template>
  <div></div>
</template>

<script>
import { deletePrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
export default {
  name: 'volume-delete',
  methods: {
    openConfirm (id) {
      detailPrivateCloudVolume(id).then(res => {
        this.$Modal.confirm({
          title: '删除卷',
          content: '确认删除此卷「' + res.data.volume.name + '」吗？删除卷是不可恢复的。卷中所有的数据都会被移除！',
          onOk: () => {
            this.delete(id)
          }
        })
      }).catch(res => {
        this.$Notice.error({
          title: '获取数据失败！'
        })
      })
    },
    // 删除卷
    delete (id) {
      deletePrivateCloudVolume(id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.$emit('callback')
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
